<template>
  <div class="app-container">
    <el-card>
      <el-button type="primary" size="small" @click="goBack()">返回</el-button>
      <el-form v-model="addAppVersionForm" style="padding-top: 20px">
        <el-form-item label="App类型:">
          <el-select clearable v-model="addAppVersionForm.useType" @change="platformTypeChange">
            <el-option label="Android" :value="0"></el-option>
            <el-option label="iOS" :value="1"></el-option>
            <el-option label="pc软件" :value="2"></el-option>
            <el-option label="仪器端" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否强制更新：">
          <el-radio-group v-model="addAppVersionForm.isForced">
            <el-radio :label="false">否</el-radio>
            <el-radio :label="true">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="!addAppVersionForm.isForced" label="兼容版本:">
          <ElSelectTree v-model="addAppVersionForm.compatibleCodes" :data="versionList" multiple
                        :render-after-expand="false" show-checkbox check-strictly check-on-click-node :props="{
						value: 'versionCode',
						        label: 'versionName',
					}">
          </ElSelectTree>
          <!-- <el-select v-model="addAppVersionForm.compatibleCodes" multiple clearable>
            <el-option v-for="item in versioList" :key="item.versionCode" :value="item.versionCode"
              :label="item.versionName"></el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item label="versionName：">
          <el-input v-model="addAppVersionForm.versionName"></el-input>
        </el-form-item>
        <el-form-item label="downloadUrl">
          <el-input v-model="addAppVersionForm.downloadUrl"></el-input>
        </el-form-item>
        <el-form-item label="updateLog">
          <el-input v-model="addAppVersionForm.updateLog" type="textarea"></el-input>
        </el-form-item>
        <!--        <el-form-item label="describe">-->
        <!--          <el-input v-model="addAppVersionForm.describe" type="textarea"></el-input>-->
        <!--        </el-form-item>-->
        <el-form-item>
          <el-button size="small" type="primary" @click="onSubmit">
            发布
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>


  </div>
</template>

<script>
import {
  getLatestVersionInfo,
  addVersion, getVersionList
} from "@/api/system/AppVersion/AppVersion"

import {
  deepClone
} from "@/utils/index"
import {
  printObj
} from "@/utils/debug"
import {handleRes} from "@/utils/handleRes";
import {isVaild} from "@/utils/validate";

export default {
  data() {
    return {
      addAppVersionForm: {
        isForced: false,
        useType: 0,
        describe: ""
      },
      versionList: []
    }
  },
  created() {
    let queryID = this.$route.query.useType
    if (isVaild(queryID)) {
      this.addAppVersionForm.useType = queryID;
    }
    this.platformTypeChange()
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    async platformTypeChange() {
      this.versionList = []
      await this.getLatestVersionInfo()
      this.getVersionList()
    },
    async getLatestVersionInfo() {
      let param = {
        type: this.addAppVersionForm.useType
      }
      let res = await getLatestVersionInfo(param)
      handleRes(res, () => {
        this.addAppVersionForm = res.data
        if (this.addAppVersionForm == null) {
          this.addAppVersionForm = {
            useType: param.type,
            isForced: false,
            describe: ""
          }
        }
      })
    },
    getVersionList() {
      let where = [{
        "field": "useType",
        "value": this.addAppVersionForm.useType,
        "op": "equal"
      }]
      getVersionList({
        where: where
      }).then(res => {
        return res.data.total
      }).then(total => {
        return getVersionList({
          pageSize: total,
          where: where
        })
      }).then(res => {
        this.versionList = res.data.rows
      })
    },
    onSubmit() {
      let data = deepClone(this.addAppVersionForm)
      if (data.isForced) {
        data.compatibleCodes = ""
      } else {
        if (isVaild(data.compatibleCodes) && data.compatibleCodes.length > 0) {
          data.compatibleCodes = data.compatibleCodes.join(",")
        }
      }
      data.createTime = ""
      // printObj(data)
      addVersion(data).then(res => {
        if (res.code === 200) {
          this.$message.success("操作成功")
          this.platformTypeChange()
        } else {
          this.$message.warning(res.message)
        }
      })
    }
  },
}
</script>

<style>
</style>
